import { reactive } from 'vue'
import axios        from 'axios'

export const store = reactive({
    fields:         [],
    fields_loading: false,
    getFields: async () => {
        if ( store.fields_loading ) {
            while (true) {
                await new Promise(r => setTimeout(r,100));
            }
        }
        if ( store.fields.length ) {
            return store.fields;
        }
        try {
            store.fields_loading = true
            const res         = await axios.get("/api/1/rules/fields");
            store.fields_loading = false
            const  { fields } = res.data;
            store.fields      = fields;
            return store.fields;
        } catch (e) {
            console.log(e);
        }
    }
})
